import { useControlledValue } from "../helpers/useControlledValue.js";
/**
 * Hook to manage single-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected date, a function to select a date,
 *   and a function to check if a date is selected.
 */
export function useSingle(props, dateLib) {
  const {
    selected: initiallySelected,
    required,
    onSelect
  } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
  const selected = !onSelect ? internallySelected : initiallySelected;
  const {
    isSameDay
  } = dateLib;
  const isSelected = compareDate => {
    return selected ? isSameDay(selected, compareDate) : false;
  };
  const select = (triggerDate, modifiers, e) => {
    let newDate = triggerDate;
    if (!required && selected && selected && isSameDay(triggerDate, selected)) {
      // If the date is the same, clear the selection.
      newDate = undefined;
    }
    if (!onSelect) {
      setSelected(newDate);
    }
    if (required) {
      onSelect === null || onSelect === void 0 || onSelect(newDate, triggerDate, modifiers, e);
    } else {
      onSelect === null || onSelect === void 0 || onSelect(newDate, triggerDate, modifiers, e);
    }
    return newDate;
  };
  return {
    selected,
    select,
    isSelected
  };
}